import { useContext, useEffect, useRef, useState } from "react";
import AuthContext from "../../../context/auth/AuthContext";
import LandLordContext from "../../../context/landlord/LandLordContext";
import "react-toastify/dist/ReactToastify.css";
import useTranslator from "../../../hooks/useTranslator";
import { haveValue } from "../../../helper/common";
import SkorDefaultLoader from "../../../assets/img/skorDefaultLoader.gif";
import CreditsRow from "../../../components/credit-ledger/CreditsRow";

const CreditsTable = () => {
  const { _t } = useTranslator();
  const authContext = useContext(AuthContext);
  const { userType, loadMyNotifications } = authContext;

  const landLordContext = useContext(LandLordContext);
  const { loadCreditsLedgerData } = landLordContext;

  const [loading, setLoading] = useState(false);

  const [transactionHistory, setTransactionHistory] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(20);
  const [total, setTotal] = useState(0);
  const loadingRef = useRef(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async (requestedPage = page) => {
    if (loadingRef.current) return;
    loadingRef.current = true;

    setLoading(true);
    try {
      const response = await loadCreditsLedgerData({
        page: requestedPage,
        limit,
      });

      if (!response) {
        return;
      }

      const { data, total: newTotal } = response;

      setTotal(newTotal);
      setPage(requestedPage);

      setTransactionHistory((prev) =>
        requestedPage === 1 ? data : [...prev, ...data]
      );
      let userid = localStorage.getItem("saveduserid");
      loadMyNotifications(userid, userType);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      loadingRef.current = false;
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 500 &&
        !loadingRef.current &&
        transactionHistory.length < total
      ) {
        loadData(page + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [page, total, transactionHistory]);

  return (
    <>
      <div className="main-page-wrapper mb-4 position-relative profileRequestWrapper ">
        <div
          className="profile-page marless mobile-max-less mobile-max-lesshead"
          style={{ margin: 0 }}
        >
          <div className="number-properties numberProperties">
            <h2>{_t("creditsHistory")}</h2>
          </div>
        </div>
        <div className="tabs-box-pattern tabs-box-pattern-2 big_tablebg">
          <div className="tabs-item d-block p-0">
            <div className="upcoming-box ">
              <table className="upcoming-table landlord-table bigtable_set">
                <thead className="hideOnMobile">
                  <tr className="first-row">
                    <th style={{ width: "15%" }}>
                      {_t("transactionType", "Field in Credit ledger table")}
                    </th>
                    <th> {_t("credits", "Field in Credit ledger table")} </th>
                    <th> {_t("amount", "Field in Credit ledger table")} </th>
                    <th>
                      {_t("transactionStatus", "Field in Credit ledger table")}
                    </th>
                    <th style={{ width: "25%" }}>
                      {_t("profileOpenedRef", "Field in Credit ledger  table")}
                    </th>
                    <th style={{ width: "16%" }}>
                      {_t("doneByLandlord", "Field in Credit ledger table")}
                    </th>
                    <th style={{ width: "17%" }}>
                      {_t("transactionDate", "Field in Credit ledger table")}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {haveValue(transactionHistory)
                    ? transactionHistory.map((data) => (
                        <CreditsRow data={data} />
                      ))
                    : _t("noTransactionsFound")}
                </tbody>
              </table>
            </div>
            {loading ? (
              <div className="defaultSkorLoaderParent mt-3">
                <img
                  src={SkorDefaultLoader}
                  className="defaultSkorLoaderSmall"
                  alt="Example"
                />
              </div>
            ) : (
              transactionHistory?.length === 0 && (
                <div className="defaultSkorLoaderParent mt-3">
                  {_t(
                    "noTransactionsFound",
                    "Used text if there is no transaction in landlord's ledger"
                  )}
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CreditsTable;
